// extracted by mini-css-extract-plugin
export default {"changeLink":"AP-z","disabled":"BP-z","inline":"CP-z"};